import { AgoraClientId, StreamId } from 'components/features/videoCalls/types/agoraTypes'
import { VideoProfile } from 'components/features/videoCalls/fixtures/profiles'
import { isScreenShare, DevicePermissions } from 'components/features/videoCalls/helpers'
import { Collection } from 'interfaces'

export type VideoChannelOptions = {
  token: string
  channel: string
  uid: string
}

export class CallPeer {
  isScreenShare: boolean

  constructor (
    public id: StreamId,
    public streamId: StreamId | null = null,
    public isVideoMuted = true,
    public isAudioMuted = true,
    public isLocal = false,
    public isReconnection = false,
  ) {
    this.isScreenShare = isScreenShare(id)
  }
}

type CallState = 'idle' | 'progress' | 'active'
export class VideoCallsDetails {

  constructor (
    public pinnedStreamId: StreamId | null = null,
    public speakerStreamId: StreamId | null = null,
    public interrupted = false,
  ) {}
}

type MuteState = 'mute' | 'muting' | 'unmute' | 'unmuting'
export class LocalStreamState {
  constructor (
    public state: CallState = 'idle',
    public streamId: StreamId | null = null,

    public audioMuteState: MuteState = 'mute',
    public videoMuteState: MuteState = 'mute',

    public audioInputDeviceId: string | null = null,
    public audioOutputDeviceId: string | null = null,
    public videoInputDeviceId: string | null = null,

    public videoProfile: VideoProfile = '720p_6',
  ) {}
}

export class ScreenStreamState {
  constructor (
    public state: CallState = 'idle',
    public streamId: StreamId | null = null,
    public clientId: AgoraClientId | null = null,
    public isAvailable: boolean = true,
  ) {}
}

export class ClientState {
  constructor (
    public state: CallState = 'idle',
    public clientId: AgoraClientId | null = null,
  ) {}
}

export class PermissionsState {
  constructor (
    public cam: DevicePermissions | null = null,
    public mic: DevicePermissions | null = null,
  ) {}
}

export type VideoCallsAppState = {
  details: VideoCallsDetails
  peers: Collection<CallPeer, 'id'>
  client: ClientState
  localStream: LocalStreamState
  screenStream: ScreenStreamState
  permissions: PermissionsState
}
